module.exports = __webpack_public_path__ + "static/media/Service Information@2x.a312c637.jpg";